import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useBreadcrumbs } from "@/lib/use-breadcrumbs";
import {
	Link,
	Outlet,
	createFileRoute,
	useMatches,
} from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/admin/eval")({
	component: EvalLayout,
});

function EvalLayout() {
	const { t } = useTranslation("eval");
	useBreadcrumbs([
		{ label: t("admin:admin_root"), href: "/admin" },
		{ label: t("title") },
	]);
	const matches = useMatches();
	const lastMatch = matches[matches.length - 1];
	const path = lastMatch?.pathname ?? "";

	const activeTab = path.includes("/compare")
		? "compare"
		: path.includes("/runs")
			? "runs"
			: path.includes("/datasets")
				? "datasets"
				: "dashboard";

	return (
		<div className="space-y-6">
			<Tabs value={activeTab} className="w-full">
				<TabsList>
					<TabsTrigger value="dashboard" asChild>
						<Link to="/admin/eval">{t("tab_overview")}</Link>
					</TabsTrigger>
					<TabsTrigger value="datasets" asChild>
						<Link to="/admin/eval/datasets">{t("tab_datasets")}</Link>
					</TabsTrigger>
					<TabsTrigger value="runs" asChild>
						<Link to="/admin/eval/runs">{t("tab_runs")}</Link>
					</TabsTrigger>
					<TabsTrigger value="compare" asChild>
						<Link to="/admin/eval/compare">{t("tab_compare")}</Link>
					</TabsTrigger>
				</TabsList>
			</Tabs>

			<Outlet />
		</div>
	);
}
